// extracted by mini-css-extract-plugin
module.exports = {"ShoppingCard":"Styles_ShoppingCard__buBIR","TopRow":"Styles_TopRow__1w6Wx","HeadRow":"Styles_HeadRow__29jvB"};